var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wallet",
    xmlns: "http://www.w3.org/2000/svg",
    height: "2.01rem",
    viewBox: "0 0 26.348 25.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Wallet-2",
    "data-name": "Wallet",
    d: "M7.657,25.031A7.754,7.754,0,0,1,0,17.2V7.83A7.754,7.754,0,0,1,7.657,0H18.691a7.754,7.754,0,0,1,7.657,7.83V17.2a7.754,7.754,0,0,1-7.657,7.83ZM1.915,7.83V17.2a5.814,5.814,0,0,0,5.742,5.871H18.691A5.814,5.814,0,0,0,24.433,17.2v-.364H20.222a4.5,4.5,0,0,1-.24-8.979l.241-.007h4.21V7.83a5.814,5.814,0,0,0-5.742-5.871H7.657A5.814,5.814,0,0,0,1.915,7.83Zm15.829,4.513a2.514,2.514,0,0,0,2.286,2.528l.193.007h4.21V9.809h-4.21A2.508,2.508,0,0,0,17.744,12.343Zm2.665.9a.981.981,0,0,1-.129-1.95l.129-.008h.4a.981.981,0,0,1,.13,1.949l-.13.009ZM6.748,7.884a.981.981,0,0,1-.129-1.949l.129-.009H13.64a.981.981,0,0,1,.13,1.949l-.13.009Z",
    fill: "#199b8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.64b7c74d44ccc778adbb49f96e24eb4c.svg";
export { ForwardRef as ReactComponent };